// 30.10: moderne bildeadresse (&width=) i stedet for gamle _100x100-filnavn. Miniatyrer så knuste ut hos eier 29.10.
function fjQvBilde(url, bredde) {
  if (!url) return '';
  return url + (url.includes('?') ? '&' : '?') + 'width=' + bredde;
}

/**
 * FJ Quick View System
 * Opens product details in a modal popup
 */
(function () {
  const modal = document.getElementById('fjQuickView');
  const template = document.getElementById('fjQvTemplate');
  const content = document.getElementById('fjQvContent');
  const closeBtn = modal?.querySelector('.fj-qv-close');

  if (!modal || !template || !content) return;

  let currentProduct = null;
  let currentVariant = null;
  let pendingVariantId = null;   // variant valgt på kortet/veggen før popupen åpnet
  let lagerMap = {};             // fra /products/<handle>?view=fj-lager
  window.fjQvLager = true;       // fj-product-card.js: la popupen eie lagerteksten

  async function fetchLager(handle) {
    try {
      const r = await fetch(`/products/${handle}?view=fj-lager`, { cache: 'no-store' });
      if (!r.ok) return {};
      const j = JSON.parse((await r.text()).trim());
      return (j && j.v) || {};
    } catch (e) { return {}; }
  }
  function lagerFor(v) {
    const L = lagerMap[String(v.id)] || {};
    const tau = String(L.t) === '1';
    const lev = L.l || '';
    const lt = (L.lt || '').replace(/^Sendes innen /i, 'sendes innen ');
    if (tau) return { cls: 'fj-qv-stock', html: '<strong>På lager på Tau</strong> – klar for henting · sendes innen 1–3 dager' };
    if (v.available) {
      if (lev === 'pa_lager') return { cls: 'fj-qv-stock fj-qv-stock--lev', html: '<strong>På fjernlager</strong> – ikke på lager på Tau · ' + (lt || 'sendes innen få dager') };
      if (lev === 'bestillingsvare' || lev === 'forventet') return { cls: 'fj-qv-stock fj-qv-stock--lev', html: '<strong>Bestillingsvare</strong>' + (lt ? ' – ' + lt : '') };
      return { cls: 'fj-qv-stock fj-qv-stock--lev', html: '<strong>Fjernlager</strong> – ikke på lager på Tau · sendes normalt innen 4–28 virkedager' };
    }
    return { cls: 'fj-qv-stock fj-qv-stock--out', html: '<strong>Utsolgt</strong> i denne størrelsen/fargen' };
  }
  function renderStock() {
    const av = content.querySelector('.fj-qv-availability');
    if (!av || !currentVariant) return;
    const st = lagerFor(currentVariant);
    av.setAttribute('data-qv-done', '1');
    av.innerHTML = '<div class="' + st.cls + '"><span class="fj-qv-stock-status">' + st.html + '</span></div>';
    const btn = content.querySelector('.fj-qv-form .fj-qv-btn--primary');
    if (btn) {
      if (!btn.getAttribute('data-orig')) btn.setAttribute('data-orig', btn.innerHTML);
      if (currentVariant.available) {
        btn.disabled = false; btn.classList.remove('is-out'); btn.innerHTML = btn.getAttribute('data-orig');
      } else {
        btn.disabled = true; btn.classList.add('is-out'); btn.textContent = 'Utsolgt – velg en annen';
      }
    }
  }
  // Merk «– utsolgt» på valg som ikke finnes/kan kjøpes sammen med de andre valgene
  function refreshOptionLabels() {
    if (!currentProduct) return;
    const selects = [...content.querySelectorAll('.fj-qv-variant-select')];
    selects.forEach((sel, idx) => {
      [...sel.options].forEach((opt) => {
        const ok = currentProduct.variants.some((v) => {
          if (v['option' + (idx + 1)] !== opt.value || !v.available) return false;
          return selects.every((o, j) => j === idx || v['option' + (j + 1)] === o.value);
        });
        opt.disabled = !ok;
        opt.textContent = ok ? opt.value : opt.value + ' – utsolgt';
      });
    });
  }

  // Open modal
  function openModal() {
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  // Close modal
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      content.innerHTML = '<div class="fj-qv-loading"><div class="fj-qv-spinner"></div><p>Laster produkt...</p></div>';
    }, 250);
  }

  // Fetch product data
  async function fetchProduct(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error('Product not found');
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch product:', error);
      return null;
    }
  }

  // Badge helper
  function getBadges(product) {
    const badges = [];
    const tags = product.tags.map(t => t.toLowerCase());

    // Check for sale
    if (product.compare_at_price && product.price < product.compare_at_price) {
      badges.push({ text: 'Salg', class: 'fj-qv-badge--sale' });
    }

    // Check tags
    if (tags.some(t => t.includes('nyhet') || t.includes('new'))) {
      badges.push({ text: 'Nyhet', class: 'fj-qv-badge--new' });
    }
    if (tags.some(t => t.includes('anbefalt') || t.includes('recommended'))) {
      badges.push({ text: 'Anbefalt', class: 'fj-qv-badge--recommended' });
    }
    if (tags.some(t => t.includes('bestselger') || t.includes('bestseller'))) {
      badges.push({ text: 'Bestselger', class: 'fj-qv-badge--bestseller' });
    }

    return badges.slice(0, 2); // Max 2 badges
  }

  // Format price
  // 28.10: som resten av butikken – «4.495 kr», øre bare når de finnes («79,50 kr»)
  function formatPrice(cents) {
    const kr = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const ore = cents % 100;
    return ore ? `${kr},${String(ore).padStart(2, '0')} kr` : `${kr} kr`;
  }

  // Render product
  function renderProduct(product) {
    currentProduct = product;
    currentVariant = (pendingVariantId && product.variants.find(v => String(v.id) === String(pendingVariantId)))
      || product.variants.find(v => v.available) || product.variants[0];
    pendingVariantId = null;

    const clone = template.content.cloneNode(true);

    // Vendor
    const vendor = clone.querySelector('.fj-qv-vendor');
    if (product.vendor) {
      vendor.textContent = product.vendor;
    } else {
      vendor.style.display = 'none';
    }

    // Title
    clone.querySelector('.fj-qv-title').textContent = product.title;

    // Badges
    const badgesContainer = clone.querySelector('.fj-qv-badges');
    const badges = getBadges(product);
    badges.forEach(badge => {
      const span = document.createElement('span');
      span.className = `fj-qv-badge ${badge.class}`;
      span.textContent = badge.text;
      badgesContainer.appendChild(span);
    });

    // Main image
    const img = clone.querySelector('.fj-qv-img');
    if (product.featured_image) {
      img.src = fjQvBilde(product.featured_image, 600);
      img.alt = product.title;
    }

    // Thumbnails
    const thumbsContainer = clone.querySelector('.fj-qv-thumbnails');
    if (product.images && product.images.length > 1) {
      product.images.slice(0, 6).forEach((imgUrl, idx) => {
        const thumb = document.createElement('div');
        thumb.className = `fj-qv-thumb ${idx === 0 ? 'is-active' : ''}`;
        thumb.innerHTML = `<img src="${fjQvBilde(imgUrl, 100)}" alt="">`;
        thumb.querySelector('img').addEventListener('error', (e) => { if (e.target.src !== imgUrl) e.target.src = imgUrl; }, { once: true });
        thumb.addEventListener('click', () => {
          img.src = fjQvBilde(imgUrl, 600);
          thumbsContainer.querySelectorAll('.fj-qv-thumb').forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
        thumbsContainer.appendChild(thumb);
      });
    }

    // Price
    const priceContainer = clone.querySelector('.fj-qv-price');
    priceContainer.innerHTML = `<span class="fj-qv-price--current">${formatPrice(product.price)}</span>`;

    if (product.compare_at_price && product.compare_at_price > product.price) {
      const savings = product.compare_at_price - product.price;
      const savingsPercent = Math.round((savings / product.compare_at_price) * 100);
      priceContainer.innerHTML += `<span class="fj-qv-price--compare">${formatPrice(product.compare_at_price)}</span>`;
      priceContainer.innerHTML += `<span class="fj-qv-price--save">Spar ${savingsPercent}%</span>`;
    }

    // Rating (if available from metafields)
    const ratingContainer = clone.querySelector('.fj-qv-rating');
    const ratingValue = product.metafields?.reviews?.rating?.value || 0;
    const ratingCount = product.metafields?.reviews?.rating_count || 0;

    if (ratingValue > 0) {
      const fullStars = Math.floor(ratingValue);
      const decimal = ratingValue % 1;
      const hasHalf = decimal >= 0.25 && decimal < 0.75;
      let emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
      if (decimal >= 0.75) emptyStars--;

      let starsHTML = '';

      // Full stars
      for (let i = 0; i < fullStars; i++) {
        starsHTML += `<svg class="fj-qv-star fj-qv-star--full" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>`;
      }

      // Half star
      if (hasHalf) {
        starsHTML += `<svg class="fj-qv-star fj-qv-star--half" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="half-qv">
              <stop offset="50%" stop-color="#fbbf24"/>
              <stop offset="50%" stop-color="rgba(0,0,0,0.15)"/>
            </linearGradient>
          </defs>
          <path fill="url(#half-qv)" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>`;
      }

      // Empty stars
      for (let i = 0; i < emptyStars; i++) {
        starsHTML += `<svg class="fj-qv-star fj-qv-star--empty" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>`;
      }

      ratingContainer.innerHTML = `
        <div class="fj-qv-stars">${starsHTML}</div>
        ${ratingCount > 0 ? `<span class="fj-qv-rating-count">(${ratingCount})</span>` : ''}
      `;
    } else {
      ratingContainer.style.display = 'none';
    }

    // Hide short description - we only use accordion now
    const desc = clone.querySelector('.fj-qv-description');
    if (desc) {
      desc.style.display = 'none';
    }

    // Accordion: Full Description - starter sammenslaatt.
    // Var den aapen, ble beskrivelsen saa lang at "Legg i kurv" havnet
    // langt under skjermkanten. Ett klikk unna er nok.
    const fullDescEl = clone.querySelector('.fj-qv-full-description');
    const fullDescItem = fullDescEl?.closest('.fj-qv-accordion-item');
    if (product.description && fullDescEl) {
      fullDescEl.innerHTML = product.description;
    } else if (fullDescItem) {
      fullDescItem.style.display = 'none';
    }

    // Accordion: Technical Specs
    const techSpecsEl = clone.querySelector('.fj-qv-tech-specs');
    const techSpecsItem = techSpecsEl?.closest('.fj-qv-accordion-item');
    const techSpecs = product.metafields?.custom?.technical_specs;
    if (techSpecs && techSpecsEl) {
      techSpecsEl.textContent = techSpecs;
    } else if (techSpecsItem) {
      techSpecsItem.style.display = 'none';
    }

    // Accordion: Delivery Info
    const deliveryInfoEl = clone.querySelector('.fj-qv-delivery-info');
    const deliveryInfoItem = deliveryInfoEl?.closest('.fj-qv-accordion-item');
    const deliveryInfo = product.metafields?.custom?.delivery_info;
    if (deliveryInfo && deliveryInfoEl) {
      deliveryInfoEl.textContent = deliveryInfo;
    } else if (deliveryInfoItem) {
      deliveryInfoItem.style.display = 'none';
    }

    // Availability
    const availabilityContainer = clone.querySelector('.fj-qv-availability');
    availabilityContainer.setAttribute('data-qv-done', '1');
    availabilityContainer.innerHTML = '<div class="fj-qv-stock"><span class="fj-qv-stock-status">Sjekker lager på Tau …</span></div>';

    // Variants - Dropdown style
    const variantsContainer = clone.querySelector('.fj-qv-variants');
    if (product.options && product.options.length > 0 && product.variants.length > 1) {
      product.options.forEach((option, optionIndex) => {
        const group = document.createElement('div');
        group.className = 'fj-qv-variant-group';

        const label = document.createElement('label');
        label.className = 'fj-qv-variant-label';
        label.htmlFor = `fj-qv-select-${optionIndex}`;
        label.textContent = option.name;
        group.appendChild(label);

        // Create dropdown select
        const select = document.createElement('select');
        select.className = 'fj-qv-variant-select';
        select.id = `fj-qv-select-${optionIndex}`;
        select.name = `fj-qv-option-${optionIndex}`;

        // Get unique values for this option
        const values = [...new Set(option.values)];

        values.forEach((value) => {
          const optionEl = document.createElement('option');
          optionEl.value = value;
          optionEl.textContent = value;

          // Check if this is the selected variant's value
          if (currentVariant[`option${optionIndex + 1}`] === value) {
            optionEl.selected = true;
          }

          select.appendChild(optionEl);
        });

        select.addEventListener('change', () => handleVariantChange());

        group.appendChild(select);
        // v11 (John 27.10: «ryddig, kort og enkelt»): knapper i stedet for nedtrekk. Selecten beholdes skjult som kilde for logikken.
        const pills = document.createElement('div');
        pills.className = 'fj-qv-pills';
        values.forEach((value) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'fj-qv-pill'; b.textContent = value; b.dataset.value = value;
          if (currentVariant[`option${optionIndex + 1}`] === value) b.classList.add('is-active');
          b.addEventListener('click', () => { select.value = value; select.dispatchEvent(new Event('change')); });
          pills.appendChild(b);
        });
        group.appendChild(pills);
        variantsContainer.appendChild(group);
      });
    } else {
      variantsContainer.style.display = 'none';
    }

    // Form
    const form = clone.querySelector('.fj-qv-form');
    const variantInput = form.querySelector('.fj-qv-variant-id');
    variantInput.value = currentVariant.id;

    // HULL: varer med paakrevd gravering (teineskilt, felleskilt) kunne
    // legges i kurven herfra UTEN graveringstekst - popupen har ingen
    // felt for det. Samme hull som kortene hadde. Send kunden til
    // produktsida i stedet, der feltene finnes og er paakrevde.
    const kreverGravering = (product.tags || [])
      .some(t => ['teineskilt', 'felleskilt', 'gravering'].includes(String(t).toLowerCase()));
    if (kreverGravering) {
      const lenke = document.createElement('a');
      lenke.className = 'fj-qv-add fj-qv-add--gravering';
      lenke.href = `/products/${product.handle}`;
      lenke.textContent = 'Velg gravering \u2192';
      const knapp = form.querySelector('.fj-qv-add');
      if (knapp) knapp.replaceWith(lenke); else form.appendChild(lenke);
      const merk = document.createElement('p');
      merk.className = 'fj-qv-gravering-merk';
      merk.textContent = 'Dette skiltet graveres med din tekst \u2014 fyll inn opplysningene p\u00e5 produktsiden.';
      lenke.insertAdjacentElement('afterend', merk);
    } else {
      form.addEventListener('submit', handleAddToCart);
    }

    // Full product link
    const fullLink = clone.querySelector('.fj-qv-full-link');
    fullLink.href = `/products/${product.handle}`;

    // Replace content
    // v11 (27.10, John: «info om produktet må komme raskere frem»): på mobil legges bilde og tittel/pris/lager
    // side om side øverst, kjøpsdelen rett under, så en kort tekst med «Les mer» (åpner Produktdetaljer).
    if (window.matchMedia('(max-width: 768px)').matches) {
      const grid = clone.querySelector('.fj-qv-grid');
      const media = clone.querySelector('.fj-qv-media');
      const info = clone.querySelector('.fj-qv-info');
      if (grid && media && info) {
        const head = document.createElement('div'); head.className = 'fj-qv-head';
        const txt = document.createElement('div'); txt.className = 'fj-qv-headtxt';
        ['.fj-qv-vendor', '.fj-qv-title', '.fj-qv-price-wrapper', '.fj-qv-availability'].forEach((sel) => { const el = info.querySelector(sel); if (el) txt.appendChild(el); });
        grid.insertBefore(head, media); head.appendChild(media); head.appendChild(txt);
        const th = media.querySelector('.fj-qv-thumbnails');
        if (th) { if (th.children.length > 1) grid.insertBefore(th, info); else th.remove(); }
        const form = info.querySelector('.fj-qv-form');
        const acc = info.querySelector('.fj-qv-accordion');
        if (form && acc) info.insertBefore(form, acc);
        // 28.10: DOMParser gjør om &amp; o.l. til tegn (før sto det «Fiske &amp; Jakt» i teksten)
        const d = (new DOMParser().parseFromString((product.description || '').replace(/<[^>]+>/g, ' '), 'text/html').body.textContent || '').replace(/\s+/g, ' ').trim();
        if (d && form) {
          const t = document.createElement('p'); t.className = 'fj-qv-teaser';
          t.textContent = d.length > 170 ? d.slice(0, 170).replace(/\s+\S*$/, '') + '… ' : d + ' ';
          const more = document.createElement('button'); more.type = 'button'; more.className = 'fj-qv-teaser__more'; more.textContent = 'Les mer';
          more.addEventListener('click', () => {
            const h = content.querySelector('.fj-qv-accordion-item .fj-qv-accordion-header');
            if (!h) return;
            if (!h.closest('.fj-qv-accordion-item').classList.contains('is-open')) h.click();
            h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          t.appendChild(more);
          form.insertAdjacentElement('afterend', t);
        }
      }
    }
    content.innerHTML = '';
    content.appendChild(clone);
    refreshOptionLabels();
    renderStock();
    syncPills();

    // Load related products
    loadRelatedProducts(product);
  }

  // Fetch related products from same collection or by tags
  async function loadRelatedProducts(product) {
    const relatedGrid = content.querySelector('.fj-qv-related-grid');
    if (!relatedGrid) return;

    try {
      // Get products from same collection (via Shopify's product recommendations API)
      const response = await fetch(`/recommendations/products.json?product_id=${product.id}&limit=4`);

      if (!response.ok) {
        relatedGrid.parentElement.style.display = 'none';
        return;
      }

      const data = await response.json();
      const relatedProducts = data.products || [];

      if (relatedProducts.length === 0) {
        relatedGrid.parentElement.style.display = 'none';
        return;
      }

      // Render related products
      relatedProducts.forEach(relatedProduct => {
        const card = document.createElement('div');
        card.className = 'fj-qv-related-card';
        const firstVariantId = relatedProduct.variants?.[0]?.id || '';
        card.innerHTML = `
          <button type="button" class="fj-qv-related-img" data-quick-view="${relatedProduct.handle}">
            <img src="${fjQvBilde(relatedProduct.featured_image, 200) || ''}"
                 alt="${relatedProduct.title}"
                 loading="lazy">
          </button>
          <div class="fj-qv-related-info">
            <button type="button" class="fj-qv-related-name" data-quick-view="${relatedProduct.handle}">${relatedProduct.title}</button>
            <div class="fj-qv-related-price">${formatPrice(relatedProduct.price)}</div>
            <button type="button" class="fj-qv-related-add" data-variant-id="${firstVariantId}">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              Legg i kurv
            </button>
          </div>
        `;
        relatedGrid.appendChild(card);
      });

      // Add event listener for related product clicks
      relatedGrid.addEventListener('click', async (e) => {
        const quickViewBtn = e.target.closest('[data-quick-view]');
        const addToCartBtn = e.target.closest('.fj-qv-related-add');

        if (quickViewBtn) {
          e.preventDefault();
          e.stopPropagation();
          const handle = quickViewBtn.dataset.quickView;
          // Show loading state
          content.innerHTML = '<div class="fj-qv-loading"><div class="fj-qv-spinner"></div><p>Laster produkt...</p></div>';
          // Load new product into same popup
          const [newProduct, lm2] = await Promise.all([fetchProduct(handle), fetchLager(handle)]);
          lagerMap = lm2 || {};
          if (newProduct) {
            renderProduct(newProduct);
          } else {
            content.innerHTML = '<div class="fj-qv-loading"><p>Kunne ikke laste produktet. Prøv igjen.</p></div>';
          }
        }

        if (addToCartBtn && !addToCartBtn.classList.contains('is-loading')) {
          e.preventDefault();
          e.stopPropagation();
          const variantId = addToCartBtn.dataset.variantId;
          if (variantId) {
            addToCartBtn.classList.add('is-loading');
            const originalHTML = addToCartBtn.innerHTML;
            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
              });
              if (response.ok) {
                addToCartBtn.innerHTML = `
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  Lagt til!
                `;
                // Update cart count
                const cartCount = document.querySelector('.cart-count-bubble span, .fj-cart-badge');
                if (cartCount) {
                  const currentCount = parseInt(cartCount.textContent || '0');
                  cartCount.textContent = currentCount + 1;
                }
                setTimeout(() => {
                  addToCartBtn.innerHTML = originalHTML;
                  addToCartBtn.classList.remove('is-loading');
                }, 2000);
              } else {
                throw new Error('Failed to add');
              }
            } catch (err) {
              console.error('Add to cart failed:', err);
              addToCartBtn.classList.remove('is-loading');
            }
          }
        }
      });

    } catch (error) {
      console.error('Failed to load related products:', error);
      relatedGrid.parentElement.style.display = 'none';
    }
  }

  // v11: speil select-tilstand (valgt/utsolgt) til knappene
  function syncPills() {
    content.querySelectorAll('.fj-qv-variant-group').forEach((group) => {
      const sel = group.querySelector('select');
      if (!sel) return;
      [...sel.options].forEach((o) => {
        const p = [...group.querySelectorAll('.fj-qv-pill')].find((x) => x.dataset.value === o.value);
        if (!p) return;
        p.classList.toggle('is-active', o.selected);
        p.classList.toggle('is-out', !!o.disabled || /utsolgt/i.test(o.textContent));
      });
    });
  }

  // Handle variant selection
  function handleVariantChange() {
    const form = content.querySelector('.fj-qv-form');
    const selectedOptions = {};

    currentProduct.options.forEach((option, idx) => {
      const select = content.querySelector(`select[name="fj-qv-option-${idx}"]`);
      if (select) {
        selectedOptions[`option${idx + 1}`] = select.value;
      }
    });

    // Find matching variant
    const variant = currentProduct.variants.find(v => {
      return Object.keys(selectedOptions).every(key => v[key] === selectedOptions[key]);
    });

    if (variant) {
      currentVariant = variant;
      form.querySelector('.fj-qv-variant-id').value = variant.id;

      // Update price
      // v11: prisen ligger i .fj-qv-head på mobil (ikke i .fj-qv-info) – slå opp i hele popupen
      const priceContainer = content.querySelector('.fj-qv-price');
      priceContainer.innerHTML = `<span class="fj-qv-price--current">${formatPrice(variant.price)}</span>`;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const savings = variant.compare_at_price - variant.price;
        const savingsPercent = Math.round((savings / variant.compare_at_price) * 100);
        priceContainer.innerHTML += `<span class="fj-qv-price--compare">${formatPrice(variant.compare_at_price)}</span>`;
        priceContainer.innerHTML += `<span class="fj-qv-price--save">Spar ${savingsPercent}%</span>`;
      }

      renderStock();
      refreshOptionLabels();
      syncPills();
    } else {
      syncPills();
      currentVariant = null;
      const av = content.querySelector('.fj-qv-availability');
      if (av) av.innerHTML = '<div class="fj-qv-stock fj-qv-stock--out"><span class="fj-qv-stock-status"><strong>Finnes ikke</strong> i denne kombinasjonen</span></div>';
      const btn = form.querySelector('.fj-qv-btn--primary');
      if (btn) { btn.disabled = true; btn.classList.add('is-out'); btn.textContent = 'Velg en annen kombinasjon'; }
    }
  }

  // Handle add to cart
  async function handleAddToCart(e) {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    form.classList.add('is-loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        let msg = 'Kunne ikke legge varen i kurven.';
        try { const j = await response.json(); msg = j.description || j.message || msg; } catch (_) {}
        throw new Error(msg);
      }
      form.querySelectorAll('.fj-qv-error').forEach(el => el.remove());

      // Show success message
      const successMsg = document.createElement('div');
      successMsg.className = 'fj-qv-success is-visible';
      successMsg.textContent = 'Produktet ble lagt til i handlekurven!';
      form.appendChild(successMsg);

      // Update cart count if exists
      const cartCount = document.querySelector('.cart-count-bubble span, .fj-cart-badge');
      if (cartCount) {
        const currentCount = parseInt(cartCount.textContent || '0');
        const quantity = parseInt(formData.get('quantity') || '1');
        cartCount.textContent = currentCount + quantity;
      }

      setTimeout(() => {
        successMsg.classList.remove('is-visible');
        setTimeout(() => successMsg.remove(), 300);
      }, 3000);

    } catch (error) {
      console.error('Add to cart failed:', error);
      form.querySelectorAll('.fj-qv-error').forEach(el => el.remove());
      const err = document.createElement('div');
      err.className = 'fj-qv-error';
      err.textContent = error.message || 'Kunne ikke legge varen i kurven.';
      form.appendChild(err);
    } finally {
      form.classList.remove('is-loading');
    }
  }

  // Event listeners
  closeBtn?.addEventListener('click', closeModal);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });

  // Accordion toggle in Quick View
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.fj-qv-accordion-header');
    if (!header) return;

    // Only handle clicks within Quick View modal
    if (!header.closest('.fj-qv-overlay')) return;

    e.preventDefault();
    e.stopPropagation();

    const item = header.closest('.fj-qv-accordion-item');
    if (!item) return;

    const content = item.querySelector('.fj-qv-accordion-content');
    if (!content) return;

    // Toggle accordion
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      item.classList.remove('is-open');
      content.style.maxHeight = '0';
    } else {
      // Close other accordions first
      const modalContainer = item.closest('.fj-qv-overlay');
      if (modalContainer) {
        modalContainer.querySelectorAll('.fj-qv-accordion-item.is-open').forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('is-open');
            const otherContent = otherItem.querySelector('.fj-qv-accordion-content');
            if (otherContent) otherContent.style.maxHeight = '0';
          }
        });
      }

      // Open this one
      item.classList.add('is-open');
      const inner = content.querySelector('.fj-qv-accordion-inner');
      if (inner) {
        content.style.maxHeight = inner.scrollHeight + 20 + 'px';
      }
    }
  });

  // v11 (John 27.10: «det er tregt … info må komme raskere»): produkt + lager hentes én gang per handle og
  // forhåndshentes ved berøring/hover og for Ukas utvalgte når siden er ferdig lastet. Lager er ferskvare: 90 s.
  const _fjCache = {};
  function hentBegge(handle) {
    const c = _fjCache[handle];
    if (c && Date.now() - c.t < 90000) return c.p;
    const p = Promise.all([fetchProduct(handle), fetchLager(handle)]).then((r) => { if (!r[0]) delete _fjCache[handle]; return r; });
    _fjCache[handle] = { t: Date.now(), p };
    return p;
  }
  function forhent(el) {
    const t = el && el.closest && el.closest('.fj-quick-view-trigger');
    const h = t && t.dataset.productHandle;
    if (h && !_fjCache[h]) hentBegge(h);
  }
  document.addEventListener('touchstart', (e) => forhent(e.target), { passive: true });
  document.addEventListener('mouseover', (e) => forhent(e.target), { passive: true });
  (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(() => {
    document.querySelectorAll('.fj-hero__prow[data-product-handle]').forEach((a) => { if (a.offsetParent) forhent(a); });
  });

  async function openQuickViewByHandle(productHandle, e) {
    if (!productHandle) return;

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    openModal();

    const [product, lm] = await hentBegge(productHandle);
    lagerMap = lm || {};
    if (product) {
      renderProduct(product);
    } else {
      content.innerHTML = '<div class="fj-qv-loading"><p>Kunne ikke laste produktet. Prøv igjen.</p></div>';
    }
  }

  // Trigger buttons
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('.fj-quick-view-trigger');
    if (!trigger) return;
    pendingVariantId = trigger.dataset.fjVariant || trigger.dataset.selectedVariant || null;
    await openQuickViewByHandle(trigger.dataset.productHandle, e);
  });

  // Product links inside guides/articles -> open quick view popup instead of leaving page
  document.addEventListener('click', async (e) => {
    const articleLink = e.target.closest('.article-template__content a[href*="/products/"]');
    if (!articleLink) return;

    const href = articleLink.getAttribute('href') || '';
    const match = href.match(/\/products\/([a-z0-9-]+)/i);
    if (!match) return;

    await openQuickViewByHandle(match[1], e);
  });

  // Handle Shopify section re-renders
  document.addEventListener('shopify:section:load', () => {
    // Quick View is already listening via delegation, no re-init needed
  });
})();
